export const hasLength = (value: string | readonly unknown[]): boolean => value.length > 0;
